import request from '@/utils/request';

export const login = (params) => {
  return request('/app_api/v1/auth/login', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}


//    签证订单列表
export function query(params) {
  return request('/app_api/v1/visaorder/query', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}
export function saveotherconfig(params) {
  return request('/org_api/v1/org/saveotherconfig', {
    method: 'post',
    data: params//post请求使用post
  })
}

//    查询当前用户保险订单记录
export function queryInsurance(params) {
  return request('/app_api/v1/insurance/query', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}

//    订单状态状态
export function orderstatusselect(params) {
  return request('/app_api/v1/visaorder/orderstatusselect', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}

//    订单申请人状态
export function orderapplcantstatusselect(params) {
  return request('/app_api/v1/visaorder/orderapplcantstatusselect', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}
//    申请人解锁支付状态
export function cancelpay(params) {
  return request('/org_api/v1/orgfinance/cancelpay', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}
//    保险订单状态
export function insuranceorderstatusselect(params) {
  return request('/app_api/v1/insurance/insuranceorderstatusselect', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}


//    订单详情
export function orderdetail(params) {
  
  // return request('/app_api/v1/visaorder/orderdetail', {
  return request('/org_api/v1/order/orderdetail', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}

// 修改申请人信息接口
export const upadateorderapplicants = (params) => {
  return request('/app_api/v1/visaorder/upadateorderapplicants', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}

// 添加申请人信息接口
export const addorderapplicants = (params) => {
  return request('/org_api/v1/orgfinance/addorderapplicant', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}
export const connectmerchant = (params) => {
  return request('/org_api/v1/order/connectmerchant', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}
export const connectcorecustomer = (params) => {
  return request('/org_api/v1/order/connectcorecustomer', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}
//    查询申请人资料
export function applicantdocs(params) {
  return request('/app_api/v1/visaorder/applicantdocs', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}

// 电子资料上传
export const applicantdataupload = (params) => {
  return request('/app_api/v1/visaorder/applicantdataupload', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}

// 护照信息识别(保存信息)
export const postuploadpassport = (params) => {
  return request('/country_api/v1/publicapi/postuploadpassport', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}


// 保存护照信息(保存信息)
export const savepassportinfo = (params) => {
  return request('/country_api/v1/publicapi/savepassportinfo', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}


// 查询当前订单可选择签证中心
export const getvisacenters = (params) => {
  return request('/app_api/v1/visaorder/getvisacenters', {
    method: 'get',
    params: { ...params }//post请求使用post
  })
}

// 修改赴馆日期信息接口
export const upadateorderembassydate = (params) => {
  return request('/app_api/v1/visaorder/upadateorderembassydate', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}

// 确认下单接口
export const confirmorder = (params) => {
  return request('/app_api/v1/visaorder/confirmorder', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}

export const balancepayment = (params) => {
  return request('/app_api/v1/visaorder/balancepayment', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}


// 获取商铺余额
export const getbalance = (params) => {
  return request('/app_api/v1/user/getbalance', {
    method: 'get',
    params: { ...params }//post请求使用post
  })
}

// 获取充值套餐
export const getrechargepackages = (params) => {
  return request('/app_api/v1/user/getrechargepackages', {
    method: 'get',
    params: { ...params }//post请求使用post
  })
}

// 购买充值订单
export const createrechargeorder = (params) => {
  return request('/app_api/v1/user/createrechargeorder', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}


// 上传图片-会删除之前上传的所有图片
export const savedocimg = (params) => {
  return request('/country_api/v1/publicapi/savedocimgnodel', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}

// 更新指定doc文件
export const updatedocimg = (params) => {
  return request('/country_api/v1/publicapi/updatedocimg', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}

// 上传图片-直接新增图片
export const savedocimgnodel = (params) => {
  return request('/country_api/v1/publicapi/savedocimgnodel', {
    method: 'post',
    data: { ...params }//post请求使用post
  })

}

// 删除doc文件-删除指定文件
export const deletedocimgtwo = (params) => {
  return request('/country_api/v1/publicapi/deletedocimgtwo', {
    method: 'get',
    params: { ...params }//post请求使用post
  })
}

// 当前商铺用户（下拉框用）
export const merchatuserlist = (params) => {
  return request('/app_api/v1/visaorder/merchatuserlist', {
    method: 'get',
    params: { ...params }//post请求使用post
  })
}

// 取消订单接口
export const cancelorder = (params) => {
  return request('/app_api/v1/visaorder/cancelorder', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}

// 查询充值订单
export const getrechargeorder = (params) => {
  return request('/app_api/v1/user/getrechargeorder', {
    method: 'get',
    params: { ...params }//post请求使用post
  })
}

// 分页订单申请人记录
export const queryorderapplicants = (params) => {
  return new Promise((resolve, reject) => {
    if(!params.OrderId) {
      reject({
        code: 400,
        msg: '订单id不能为空'
      })
      return
    }
    request('/app_api/v1/visaorder/queryorderapplicants', {
      method: 'get',
      params: { ...params }//post请求使用post
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 申请人状态修改
export const orderapplicantmodifystatus = (params) => {
  return request('/org_api/v1/orgfinance/orderapplicantmodifystatus', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}

// 申请发票详情
export const orderinvoice = (params) => {
  return request('/org_api/v1/order/orderinvoice', {
    method: 'post',
    data: { ...params }
  })
}
// 上传发票
export const orderuploadinvoice = (params) => {
  return request('/org_api/v1/order/orderuploadinvoice', {
    method: 'post',
    data: { ...params }
  })
}
// 查询订单机构
export const queryorderorg = (params) => {
  return request('/org_api/v1/order/queryorderorg', {
    method: 'get',
    params: { ...params }
  })
}
// 申请发票审核
export const orderinvoiceaudit = (params) => {
  return request('/org_api/v1/order/orderinvoiceaudit', {
    method: 'post',
    data: { ...params }
  })
}

// 批量下载申请人资料
export const downloadapplicantsdata = (params, type = 0) => {
  return request('/org_api/v1/orgfinance/downloadapplicantsdata', {
    method: 'post',
    data: { ...params, type }//post请求使用post
  })
}

// 修改申请人身份类型
export const orderapplicantmodifyidentity = (params) => {
  return request('/org_api/v1/orgfinance/orderapplicantmodifyidentity', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}

// 申请人备注
export const orderapplicantremarks = (params) => {
  return request('/org_api/v1/orgfinance/orderapplicantremarks', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}
// 申请人上传签证页
export const uploadvisapage = (params) => {
  return request('/org_api/v1/orgfinance/uploadvisapage', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}
// 订单退款
export const orderrefund = (params) => {
  return request('/org_api/v1/orgfinance/orderrefund', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}
// 查询邮件
export const seachorderapplicantemailhistory = (params) => {
  return request('/org_api/v1/orgfinance/seachorderapplicantemailhistory', {
    method: 'get',
    params: { ...params }
  })
}
// 查询邮件
export const seachnewemaildata = (params) => {
  return request('/org_api/v1/orgfinance/seachnewemaildata', {
    method: 'get',
    params: { ...params }
  })
}

// 批量提交到大使馆网站
export const batchsubmitapplicant = (params) => {
  return request('/org_api/v1/orgfinance/batchsubmitapplicant', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}
//    查询支付结果
export function paycallback(params) {
  return request('/org_api/v1/orgfinance/paycallback', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}

// 插件循环查询支付结果
export function paycallbackloop(params) {
  return request('/org_api/v1/orgfinance/seachpaycallback', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}
//  查询当前订单可用优惠券
export function getordercoupon(params) {
  return request('/app_api/v1/user/getordercoupon', {
    method: 'get',
    params: { ...params }
  })
}


//  申请人状态查询
export function applicantstatus(params) {
  return request('/org_api/v1/orgfinance/applicantstatus', {
    method: 'get',
    params: { ...params }//get请求使用params,直接拼接在请求url上
  })
}
// 我的订单--下载资料包
export const downloadapplicantdata = (params) => {
  return request('/app_api/v1/visaorder/downloadapplicantdata', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}
//批量取消vfs
export const batchcancelvfsorder = (params) => {
  return request('/org_api/v1/orgfinance/batchcancelvfsorder', {
    method: 'post',
    data: { ...params }//post请求使用post
  })
}


// 导入excel
export function processtemplate(params) {
  return request('/app_api/v1/visaorder/processtemplate', {
    method: 'post',
    data: { ...params }
  })
}

// 修改订单状态
export function ordermodifystatus(params) {
  return request('/org_api/v1/orgfinance/ordermodifystatus', {
    method: 'post',
    data: { ...params }
  })
}

// 修改预计出行日期接口
export function upadateorderdeparturetime(params) {
  return request('/org_api/v1/orgfinance/upadateorderdeparturetime', {
    method: 'post',
    data: { ...params }
  })
}

// 修改预计出签日期接口
export function upadateorderplanvisadate(params) {
  return request('/org_api/v1/order/upadateorderplanvisadate', {
    method: 'post',
    data: { ...params }
  })
}

// 修改订单收银
export function upadateorderpaytypeandorderprice(params) {
  return request('/org_api/v1/order/upadateorderpaytypeandorderprice', {
    method: 'post',
    data: { ...params }
  })
}

//获取微信小程序分享二维码
export function wechatshareqrcode(params) {
  return request('/app_api/v1/appinfo/wechatshareqrcode', {
    method: 'post',
    data: { ...params }
  })
} 


//获取平台默认小程序
export function getdefaultappinfo(params) {
  return request('/org_api/v1/orgfinance/getdefaultappinfo', {
    method: 'get',
    params: { ...params }
  })
}


//获取翻译信息
// 0 - 国家，1 - 省份，2 - 城市，3 - 地址，4 - 公司\学校，5 - 职位\学历\课程\业务，6 - 背景陈述\其他说明
export function gettranslateentity(params) {
  return request('/country_api/v1/publicapi/gettranslateentity', {
    method: 'get',
    params: { ...params }
  })
}


//平台订单关联功能 
export function connectorder(params) {
  return request('/org_api/v1/order/connectorder', {
    method: 'post',
    data: { ...params }
  })
}

//平台订单关联功能 
export function bindwechatname(params) {
  return request('/org_api/v1/order/bindwechatname', {
    method: 'post',
    data: { ...params }
  })
}


//订单导入护照 
export function orderimportpassport(params) {
  return request('/org_api/v1/order/orderimportpassport', {
    method: 'post',
    data: { ...params }
  })
}

//订单支付方式 
export function paytypeselect(params) {
  return request('/org_api/v1/orgfinance/paytypeselect', {
    method: 'get',
    params: { ...params }
  })
}

// 批量导入excel
export function batchprocesstemplate(data) {
  return request('/app_api/v1/visaorder/batchprocesstemplate', {
    method: 'post',
    data
  })
}

// 批量导失败申请人
export function batchimportapplicant(params) {
  return request('/org_api/v1/orgfinance/queryorderfaildapplicantsorg', {
    method: 'get',
    params
  })
}

// 查询快递订单详情
export function queryexpressorder(params) {
  return request('/org_api/v1/orgfinance/queryorderlogisticsinfo', {
    method: 'get',
    params
  })
}

// 查询订单面试信息
export function queryorderinterviewinfo(params) {
  return request('/org_api/v1/orgfinance/queryorderinterviewinfo', {
    method: 'get',
    params
  })
}

// 添加或修改订单面试信息
export function addorupdateorderinterviewinfo(params) {
  return request('/org_api/v1/orgfinance/addinterviewinfo', {
    method: 'post',
    data: { ...params }
  })
}

// 查询签证产品绑定收货地址
export function queryproductaddress(params) {
  return request('/org_api/v1/product/queryvisaaddress', {
    method: 'get',
    params
  })
}

// 添加物流信息
export function addlogisticsinfo(data) {
  return request('/org_api/v1/orgfinance/addlogisticsinfo', {
    method: 'post',
    data
  })
}

// 修改物流信息
export function updatelogisticsinfo(data) {
  return request('/org_api/v1/orgfinance/updatelogisticsinfo', {
    method: 'post',
    data
  })
}

// 获取订单可选流程
export function getorderflow(params) {
  return request('/org_api/v1/orgfinance/orderprocesse', {
    method: 'get',
    params
  })
}

// 修改订单用户收货信息
export function updateorderaddress(params) {
  return request('/org_api/v1/orgfinance/ordermodifyaddress', {
    method: 'post',
    data: { ...params }
  })
}

// 批量提取当前订单护照头像
export function batchextractpassport(data) {
  return request('/org_api/v1/orgfinance/croppassportavatar', {
    method: 'post',
    data
  })
}

// 批量校验当前订单护照信息
export function checkpassportinfos(data) {
  return request('/org_api/v1/orgfinance/checkpassportinfos', {
    method: 'post',
    data
  })
}
//国家列表
export function getordertoolcountry(params={}) {
  return request('/org_api/v1/org/getordertoolcountry', {
    method: 'get',
    params
  })
}